import { hashtagTextRegex, hashtagWithHashRegex } from './hashtagRegex';

export function indexOfFirstInvalidHashtagCharacter(text: string): number {
  const characters = text.split('');
  return characters.findIndex(value => !validateHashtagText(value));
}

export function validateHashtagText(text: string) {
  return hashtagTextRegex.test(text);
}

export function validateHashtag(textWithHash: string) {
  return hashtagWithHashRegex.test(textWithHash);
}
